import { AudioSubscription } from './models/audio-subscriptions.interface';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RemoteApiService } from '../core';
import { AudioSubscriptionResponseDto } from './models/audio-subscription-response-dto.interface';


@Injectable({
  providedIn: 'root'
})
export class AudioSubscriptionService {
  constructor(private remoteApi: RemoteApiService, private http: HttpClient) {}

  getAudioSubscriptions(email: string): Observable<AudioSubscriptionResponseDto[]> {
    return this.remoteApi
      .getAudioSubscriptions<AudioSubscriptionResponseDto[]>(`/audio-subscriptions/${email}`);
  }

  postAudioSubscriptions(body: AudioSubscription): Observable<AudioSubscriptionResponseDto> {
    return this.remoteApi.postAudioSubscriptions<AudioSubscriptionResponseDto>('/audio-subscriptions', body);
  }

  deleteAudioSubscriptions(id: string): Observable<any> {
    return this.remoteApi.deleteAudioSubscriptions(`/audio-subscriptions/${id}`);
  }
}
